/***************************************************************
5/27/2017
Alexander Self
Timesheet harvest table
- Displays an employees harvested trees, bags, hours, field
***************************************************************/
import React from 'react';
import { totalCount } from '../../../utils';
const TimesheetHarvestViewTable = ({ harvest }) => {
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th>Hours</th>
          <th>Trees</th>
          <th>Bags</th>
          <th>Inc. Bonus</th>
          <th>P. Index</th>
          <th>Field</th>
          <th>Block</th>
          <th>Cost Center</th>
          <th>Subaccount</th>
          <th>Round</th>
        </tr>
      </thead>
      <tbody>
        {
          harvest.map((h) => {
            return (
              <tr key={h.id}>
                <td>{ h.hours }</td>
                <td>{ h.trees }</td>
                <td>{ h.bags }</td>
                <td>${ h.incentive.toFixed(2) }</td>
                <td>{ h.pIndex }</td>
                <td>{ h.field }</td>
                <td>{ h.block }</td>
                <td>{ h.costCenter ? h.costCenter : '' }</td>
                <td>{ h.subAccount ? h.subAccount : '' }</td>
                <td>{ h.round }</td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td><center><b>{totalCount(harvest, 'hours')}</b></center></td>
          <td><center><b>{totalCount(harvest, 'trees')}</b></center></td>
          <td><center><b>{totalCount(harvest, 'bags')}</b></center></td>
          <td><center><b>${totalCount(harvest, 'incentive')}</b></center></td>
          <td><center><b>{totalCount(harvest, 'pIndex')}</b></center></td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TimesheetHarvestViewTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/view/timesheet_harvest_view_table.js